import wcShared from '@web-components/shared';

import { INews } from '../models/typing';
import newsStore from '../stores/news.store';

class NewService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getNews(): Promise<any> {
    return wcShared
      .httpCall('GET', `/api/components/what-s-new/recent?page=${newsStore.page}&per_page=10`)
      .then((r) => r.json())
      .then((response) => {
        if (response.result === 'success') {
          newsStore.recent = [...(newsStore.recent ?? []), ...(response?.data as INews[])];
          newsStore.page = response?.page;
          newsStore.pages = response?.pages;
        }
        return response;
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  postNews(id: number): Promise<any> {
    return wcShared
      .httpCall('POST', `/api/components/what-s-new/${id}/see`)
      .then((r) => r.json())
      .then((response) => {
        return response;
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  postAllNews(): Promise<any> {
    return wcShared
      .httpCall('POST', '/api/components/what-s-new/see-all')
      .then((r) => r.json())
      .then((response) => {
        return response;
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  postOpenedNews(): Promise<any> {
    return wcShared
      .httpCall('POST', '/api/components/what-s-new/opened-modal')
      .then((r) => r.json())
      .then((response) => {
        return response;
      });
  }
}

export const NewsService = new NewService();
